
type Config = {
    setup: {
        host: string
    },
    api: {
        urlV1: string
        urlSockets: string
    },
    stripe: {
        publishableKey: string
    },
    stores: StoreList
}

export type StoreList = {
    android: StoreConfig
    apple: StoreConfig
}

type StoreConfig = {
    [language: string]: string
}

export const config: Config = {
    setup: {
        host: process.env.REACT_APP_SELF_HOST || "",
    },
    api: {
        urlV1: process.env.REACT_APP_BACKEND_URL_V1 || "",
        urlSockets: process.env.REACT_APP_BACKEND_URL_WEBSOCKETS || "",
    },
    stripe: {
        publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "",
    },
    stores: {
        android: {
            en: 'https://play.google.com/store/apps/details?id=com.lanars.byzans&hl=en',
            ru: 'https://play.google.com/store/apps/details?id=com.lanars.byzans&hl=ru',
            fr: 'https://play.google.com/store/apps/details?id=com.lanars.byzans&hl=fr',
            de: 'https://play.google.com/store/apps/details?id=com.lanars.byzans&hl=de',
            'es': 'https://play.google.com/store/apps/details?id=com.lanars.byzans&hl=es',
            'zh-TW': 'https://play.google.com/store/apps/details?id=com.lanars.byzans&hl=zh-tw',
            'zh-CN': 'https://play.google.com/store/apps/details?id=com.lanars.byzans&hl=zh-cn',
        },
        apple: {
            en: 'https://apps.apple.com/us/app/byzans-chat-about-books/id1438086209',
            ru: 'https://apps.apple.com/ru/app/byzans-chat-about-books/id1438086209',
            fr: 'https://apps.apple.com/fr/app/byzans-chat-about-books/id1438086209',
            de: 'https://apps.apple.com/de/app/byzans-chat-about-books/id1438086209',
            'es': 'https://apps.apple.com/es/app/byzans-chat-about-books/id1438086209',
            'zh-TW': 'https://apps.apple.com/tw/app/byzans-chat-about-books/id1438086209',
            'zh-CN': 'https://apps.apple.com/cn/app/byzans-chat-about-books/id1438086209',
        },
    }
}

// console.log({ config })